export const SLUG_ALIASES: Record<string, string> = {
  "interior-design-bahrain": "interior-design",
  "fit-out-contracting-bahrain": "fit-out-contracting",
  "custom-joinery-bahrain": "custom-joinery",
  "mep-contracting-bahrain": "mep-contracting",
  "architectural-lighting-bahrain": "architectural-lighting",
  "digital-signage-display-bahrain": "digital-signage-display",
  "signage-decorative-metalwork-bahrain": "signage-decorative-metalwork",
  "commercial-renovation-refurbishment-bahrain":
    "commercial-renovation-refurbishment",
  "interior-design": "interior-design",
  "fit-out-turnkey": "fit-out-contracting",
  "joinery-custom-furniture": "custom-joinery",
  "mep-solutions": "mep-contracting",
  "lighting-luminaire": "architectural-lighting",
  "digital-solutions": "digital-signage-display",
  "signage-decorative": "signage-decorative-metalwork",
  "renovation-refurbishment": "commercial-renovation-refurbishment",
};
